export const resourceTypes = {
  LINK: 'link',
  DOCUMENT: 'document'
}

export const GET_RESOURCES =
  'pages/member/resourcesLibrary/getResources'
